export const isStudio = (house, edges) => Boolean(edges.find(e => e.source === house.id || e.target === house.id));

export const checkStudioGender = (house, nodes, edges, order) => {
  if (!house?.id || !order?.participant_gender) {
    return true;
  };

  const edge = edges.find(e => e.source === house.id || e.target === house.id);
  if (!edge) {
    return true;
  };

  const houses = nodes.filter(n => edge && (n.id === edge.source || n.id === edge.target));
  const houseIds = houses.map(h => h.id).filter(Boolean);

  const beds = nodes.filter(
    n => n?.type === 'BedNode' && houseIds.some(houseId => n?.parentId?.startsWith(houseId))
  );

  const participant_genders = beds
    .map(b => b?.data?.order?.participant_gender)
    .filter(Boolean);
  // Czy płeć pierwszego uczestnika jest zgodna z płcią kolejnych uczestników
  const canAdd =
    participant_genders.length === 0 || participant_genders[0] === order?.participant_gender;

  return canAdd;
};
